import { AccountVerificationType } from './AccountVerificationType';
import { AccountStatus } from './AccountStatus';
import { UserAccountAddress } from './UserAccountAddress';

export class UserAccount {
  id: number;
  userId: number;
  username: string;
  password?: string;
  displayName: string;
  firstName: string;
  lastName: string;
  organization: string;
  email: string;
  address = new UserAccountAddress();
  phoneCountryCode: number;
  phoneNumber: string;
  faxCountryCode: number;
  fax: string;
  accountStatus: AccountStatus;
  pendingVerifications: AccountVerificationType[] = [];
  completedVerifications: AccountVerificationType[] = [];
}
